import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { truncateWords, EXPERT_DESCRIPTION_WORD_LIMIT } from "./expertProfile";

// Expert bio with an inline "Read more" / "Show less" toggle. Truncates by
// word count (same limit the email uses) so the toggle only appears when the
// text was actually cut. Inline expand is preferred over a hover tooltip:
// keyboard/mobile friendly, no accidental triggers, and consistent with the
// email preview's "Read more" affordance.
export default function ExpertBio({
  description,
  wordLimit = EXPERT_DESCRIPTION_WORD_LIMIT,
  className = "text-muted small mt-1",
}) {
  const [expanded, setExpanded] = useState(false);
  if (!description) return null;

  const { text, truncated } = truncateWords(description, wordLimit);

  return (
    <div className={className}>
      {expanded ? description : text}
      {truncated && (
        <>
          {" "}
          <Button
            variant="link"
            size="sm"
            className="p-0 align-baseline"
            style={{ fontSize: "inherit" }}
            onClick={(e) => {
              e.stopPropagation();
              setExpanded((v) => !v);
            }}
          >
            {expanded ? "Show less" : "Read more"}
          </Button>
        </>
      )}
    </div>
  );
}
